import { Icon } from './Icon'
import styles from './Tooltip.module.sass'
export function Tooltip(props: { text: string }) {
	return (
		<div className={styles.wrapper}>
			<span className={styles.icon}>
				<Icon name="questionMark" />
			</span>
			<span className={styles.text}>{props.text}</span>
		</div>
	)
}
